import { render, staticRenderFns } from "./UsuarioFornecedorTabela.vue?vue&type=template&id=45b0c080&lang=html"
import script from "./UsuarioFornecedorTabela.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports